"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapOrisalesToInternalMenuItems = void 0;
const mapOrisalesToInternalMenuItems = (parentItemPath, items) => items.map((item, index) => {
  const itemPath = `${parentItemPath}/${index}/`;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- API indeed incorrectly may return value as undefined instead of empty array
  let subItems = item.items ?? [];
  const hasSubitems = [...subItems].length > 0;
  if (hasSubitems && item.url) {
    subItems = [item, ...subItems];
  }
  return {
    itemPath,
    title: item.name ?? '',
    url: item.url ?? '',
    icon: null,
    subItems: hasSubitems ? mapOrisalesToInternalMenuItems(itemPath, subItems) : [],
    openInNewTab: item.inNewTab,
    isViewable: true
  };
});
exports.mapOrisalesToInternalMenuItems = mapOrisalesToInternalMenuItems;